<template>
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div v-if="formIsEmpty" class="nav-toggle" @click="closePopup">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
      <el-popover placement="right" width="200" v-model="popupValidClose" popper-class="popup-delete black-inputs">
        <p>Êtes vous sûr de vouloir arrêter la prise de réservation</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" class="dark" type="primary" @click="popupValidClose = false">Annuler</el-button>
          <el-button type="primary" size="mini" @click="closePopup">Confirmer</el-button>
        </div>
        <div v-if="!formIsEmpty" class="nav-toggle" slot="reference" @click="popupValidClose = true">
          <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
        </div>
      </el-popover>
      <div class="nav-step">
        <div v-if='formPart1.show'>Etape 1/2</div>
        <div v-if='formPart2.show'>Etape 2/2</div>
      </div>
      <el-row class="black-inputs">
        <el-col :span="20" :offset="2" v-if="formPart1.show">
          <el-form ref="formPart1.data" :rules="rulesFormPart1" :model="formPart1.data" label-width="0px">
            <el-form-item class="civ">
              <el-radio-group v-model="formPart1.data.civ">
                <el-radio-button label="M."></el-radio-button>
                <el-radio-button label="Mme"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="name">
              <el-autocomplete v-model="formPart1.data.name" placeholder="Nom*" :fetch-suggestions="querySearchName"
                :trigger-on-focus="false" @select="handleSelectClient">
                <template slot-scope="{ item }">
                  <span class="autocomp-name">{{ item.name }} </span>
                  <span class="autocomp-prenom">{{ item.prenom }}</span>
                  <span class="autocomp-show" v-if='item.countShow > 1'>{{ item.countShow }}</span>
                  <span class="autocomp-star" v-if='item.countShow > 0'></span>
                  <span class="autocomp-noshow" v-if='item.countNoShow > 1'>{{ item.countNoShow }}</span>
                  <span class="autocomp-thumb-down" v-if='item.countNoShow > 0'></span>
                </template>
              </el-autocomplete>
            </el-form-item>
            <el-form-item prop="prenom">
              <el-input v-model="formPart1.data.prenom" placeholder="Prénom*"></el-input>
            </el-form-item>
            <el-form-item prop="telPreFix" class="tel-prefix">
              <el-input v-model="formPart1.data.telPreFix" placeholder="+33"></el-input>
            </el-form-item>
            <el-form-item prop="tel" class="tel">
              <el-input v-model="formPart1.data.tel" @input="formPart1.errorContact = false"
                placeholder="Téléphone"></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <div class="popup-takeResa-link" v-if="!showEmail" @click="showEmail = true">Avez-vous un email ?</div>
              <el-input v-if="showEmail" v-model="formPart1.data.email" placeholder="e-mail"
                @input="forceLowerCase(); formPart1.errorContact = false"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formPart1.data.societe" placeholder="Société"></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="formPart1.data.comment" :autosize="{ minRows: 3 }" type="textarea"
                placeholder="Commentaire concernant le client"></el-input>
            </el-form-item> -->
            <el-form-item v-if="formPart1.errorContact">
              <div class="errorContact">Merci de renseigner soit une adresse mail soit un numero de téléphone</div>
            </el-form-item>
            <el-form-item v-loading="formPart1.loading">
              <el-button type="primary" v-if="!formPart1.loading"
                @click="onSubmitPart1('formPart1.data')">Valider</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="18" :offset="3" v-if="formPart2.show" v-loading="formPart2.loading">
          <el-form ref="formPart2.data" :rules="rulesFormPart2" :model="formPart2.data" label-width="120px">
            <el-form-item>
              <calendar-nav />
            </el-form-item>
            <el-form-item>
              <div class="popup-takeResa_numberInput-left"><i @click="formPart2.data.nbCouvert--; checkValues()"
                  class="el-icon-minus"></i></div>
              <el-input @focus="focusNumber" @change="checkValues" type="number"
                class="text-centered popup-takeResa_numberInput" size="medium" :min="1"
                v-model="formPart2.data.nbCouvert">
              </el-input>
              <div class="popup-takeResa_numberInput-right"><i @click="formPart2.data.nbCouvert++; checkValues()"
                  class="el-icon-plus"></i></div>
            </el-form-item>
            <el-form-item>
              <el-select v-if="getSelectedDayServicesData !== null" class="text-centered" v-model="selectedService"
                @change="msServiceChange" value-key="id" placeholder="Choisissez un service">
                <el-option v-for="item in getSelectedDayServicesData" :key="item.id" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="selectedService && getServicesHoursData">
              <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null">Fermé</div>
              <el-select
                v-if="getServicesHours !== null && getServicesHoursData !== null && getServicesHoursData[selectedService.ms]"
                class="text-centered" v-model="formPart2.data.date2" value-key="id" @change="serviceChange"
                placeholder="Choisissez une heure">
                <el-option v-for="h in getServicesHoursData[selectedService.ms].tab" :key="h.id" :label="h.hour"
                  :value="h">
                  <span class="spanModified" :style="{ color: h.color }">
                    {{ h.label }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="getCashInfos && getCashInfosData && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert))">
              {{ cashInfos.type }} de {{ cashInfos.value }}€/c soit {{ Math.round((cashInfos.value *
                formPart2.data.nbCouvert)
                * 100) /
                100 }}€ CB ->
              <el-switch v-model="cashProceed" active-color="#00cec0" inactive-color="#e95d5d">
              </el-switch>
            </el-form-item>
            <el-form-item class="popup-takeResa-allergen" prop="allergen">
              <el-radio-group v-model="formPart2.data.allergen" @change="btnTakeResaDisable = false">
                <el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune intolérance ou allergie
                  <br>pour
                  l’ensemble des convives</el-radio>
                <el-radio style="white-space: normal; padding:5px 10px" :label="true">Intolérance / Allergie </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="formPart2.data.allergen" prop="allergenMessage">
              <el-input v-model="formPart2.data.allergenMessage" :autosize="{ minRows: 3 }"
                @blur="btnTakeResaDisable = false" type="textarea"
                placeholder="Merci de renseigner les intolérances / allergies"></el-input>
            </el-form-item>
            <el-form-item prop="preFix" class="rPrefix">
              <el-input v-model="formPart2.data.preFix" placeholder="Préfixe (4 lettres max.)" maxlength="4"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formPart2.data.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                placeholder="Commentaire concernant la réservation"></el-input>
            </el-form-item>
            <el-form-item prop="preFixServ" class="rPrefix">
              <el-input v-model="formPart2.data.preFixServ" placeholder="Interne (4 lettres max.)"
                maxlength="4"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="popup-takeResa-rgpd">
                <div>Offres promotionnelles (rgpd) :</div>
                <div class="checkboxes">
                  <el-checkbox v-model="formPart2.data.rgpdmail">E-mail</el-checkbox>
                  <el-checkbox v-model="formPart2.data.rgpdsms">SMS</el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="getDiscountAmount">
              <div class="popup-takeResa-promotion">
                <div>Réduction :</div>
                <div class="checkboxes">
                  <el-checkbox v-model="formPart2.data.discount">Activer la réduction de <span class="promo">{{
                    getDiscountAmount }}%</span></el-checkbox>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-button class="dark" type="primary" @click="switchForm">Précédent</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button :disabled="btnTakeResaDisable" type="primary"
                    @click="onSubmitPart2('formPart2.data')">Réserver</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import isBetween from 'dayjs/plugin/isBetween'
import { Notification } from 'element-ui'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as resaState from '../../store/types/resa-state'
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from '../../tools/fetch'
import { fetchCheckoutApp } from '../../tools/fetchHelper'
import { sendResaConfirmedMessage, sendResaTakedRestaurateur } from '../../tools/messageSender'
import { compareTime, dateToTimeStamp, formatTimeH, parseTime } from '../../tools/timeTool'
import { checkPhone, validatePrefix } from '../../tools/validator'
import CalendarNav from '../calendar/CalendarNav'

dayjs.extend(isBetween)
dayjs.locale('fr')

export default {
  name: 'PopupTakeResa',
  components: { CalendarNav },
  data() {
    return {
      formPart1: {
        data: {
          civ: 'M.',
          clientPreFix: '',
          name: '',
          email: '',
          prenom: '',
          tel: '',
          telPreFix: '+33',
          societe: '',
          comment: '',
          rgpdmail: false,
          rgpdsms: false
        },
        errorContact: false,
        loading: false,
        show: true,
        cid: ''
      },
      formPart2: {
        data: {
          nbCouvert: 2,
          date1: new Date(),
          date2: '',
          room: '',
          tids: '',
          rgpdmail: false,
          rgpdsms: false,
          preFix: '',
          preFixServ: '',
          allergen: '',
          allergenMessage: '',
          discount: false,
          discountAmount: 0
        },
        show: false,
        loading: false
      },
      tabHours: [],
      showEmail: false,
      rulesFormPart1: {},
      rulesFormPart2: {},
      popupValidClose: false,
      btnTakeResaDisable: false,
      selectedDay: null,
      selectedService: null,
      cashInfos: undefined,
      cashProceed: true
    }
  },
  computed: {
    ...mapGetters({
      getSelectedSubService: 'newServices/getSelectedSubService',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      getClientByNPC: 'newClients/getClientByNPC',
      getClientByid: 'newClients/getClientByid',
      getAllClients: 'newClients/getAllClients',
      getSelectedDay: 'calendar/getSelectedDay',
      getRoomsDatas: 'newRooms/getRoomsDatas',
      getSelectedTables: 'newRooms/getSelectedTables',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getLinkedResaIdsToTable: 'newRooms/getLinkedResaIdsToTable',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getMainServiceDataByServiceAndDay: 'newServices/getMainServiceDataByServiceAndDay',
      getThisTableIsLock: 'newRooms/getThisTableIsLock',
      getNumberOfIntervalService: 'newServices/getNumberOfIntervalService',
      getHourAvaibleForResas: 'newReservations/getHourAvaibleForResas',
      getCouvByHour: 'newReservations/getCouvByHour',
      getUser: 'newUsers/getUser',
      getUidPublic: 'newUsers/getUidPublic',
      getAllInfos: 'infos/getAllInfos',
      getSocket: 'webSockets/getSocket',
      getMainServicesForDay: 'newServices/getMainServicesForDay',
      getAllDiscount: 'discount/getAllDiscount'
    }),
    formIsEmpty: function () {
      if (this.formPart1.data.name !== '' ||
        this.formPart1.data.email !== '' ||
        this.formPart1.data.prenom !== '' ||
        this.formPart1.data.clientPreFix !== '' ||
        this.formPart1.data.tel !== '' ||
        this.formPart1.data.societe !== '' ||
        this.formPart1.data.comment !== '') {
        return false
      } else {
        return true
      }
    },
    getWeekday() {
      return this.formatDayWithLowercase(dayjs(this.getSelectedDay.date).format('dddd'))
    },
    getDiscounts() {
      const day = dayjs(this.getSelectedDay.date)
      if (!this.getAllDiscount || !this.getAllDiscount.length > 0) return []
      const discounts = this.getAllDiscount.filter(discount => {
        const startDate = dayjs(discount.dates[0]).startOf('day')
        const endDate = dayjs(discount.dates[1]).startOf('day')

        const isThisDate = day.isBetween(startDate, endDate, 'day', '[]')
        if (!isThisDate) return false
        const discountsOfDay = discount[this.getWeekday]
        if (discountsOfDay && discountsOfDay.length > 0) return true
      }).map(discount => {
        const discountsOfDay = discount[this.getWeekday]
        return discountsOfDay
      }).flat()

      return discounts
    },
    getDiscountAmount() {
      let amount = 0
      if (!this.getDiscounts || this.getDiscounts.length === 0 || !this.formPart2.data.date2.hour) return amount
      const hours = this.parseTime(this.formPart2.data.date2.hour)
      this.getDiscounts.forEach(discount => {
        const start = this.parseTime(discount.hourStart)
        const end = this.parseTime(discount.hourEnd)
        if (this.isInInterval(start, end, hours)) {
          if (amount > 0) {
            if (discount.discount < amount && discount.discount !== 0) amount = discount.discount
          } else {
            amount = discount.discount
          }
        }
      })
      return amount
    },
    pickerTables: function () {
      this.formPart2.data.tids = this.getSelectedTables
      return this.getSelectedTables
    },
    pickerRoom: function () {
      this.formPart2.data.room = this.getSelectedRoom
      return this.getSelectedRoom
    },
    pickerOptions: function () {
      let options = {}
      options.disabledDate = function (time) {
        if (time.getTime() < (Date.now() - 3600 * 1000 * 24)) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24)
        } else {
          // hack for Monday stay first day
          let d = time.getDay()
          if (d === 0) d = 7
          // looking for closedDays

          let found = this.getDaysIsClosed(d, false, time.getTime())
          return found
        }
      }
      options.firstDayOfWeek = 1
      return options
    },
    getTablesDispo: function () {
      let tables = []
      Object.entries(this.getRoomsDatas[this.pickerRoom].tables).forEach(([idTable, table]) => {
        if (!table.isBooked) {
          let tableIsLock = this.getThisTableIsLock({
            date: this.getSelectedDay,
            service: this.getSelectedMainService,
            room: table.roomid,
            id: table.id
          })
          if (!tableIsLock) tables.push(table)
        }
      })
      return tables
    },
    getServicesHoursData: function () {
      return this.tabHours
    },
    getSelectedDayServicesData: function () {
      let subServices = []
      let servicesForDay = this.getMainServicesForDay(this.getSelectedDay)
      if (servicesForDay !== undefined) {
        let count = 0
        let needToReSetSelected = false
        servicesForDay.forEach((service) => {
          if (!service.isClosed) {
            let o = {
              name: service.subName,
              value: {
                subs: service.subName,
                ms: service.name,
                id: count
              }
            }
            subServices.push(o)
            if (this.getSelectedSubService === o.name) this.selectedService = o.value
            count += 1
          } else if (this.getSelectedSubService === service.subName) {
            needToReSetSelected = true
          }
        })
        if (needToReSetSelected && subServices.length > 0) {
          this.selectedService = subServices[0].value
          this.setSelectedService({ ms: subServices[0].name, subs: subServices[0].name })
        }
        return subServices
      }
    },
    getServicesHours: function (e) {
      if (this.getSelectedDay !== '' && this.getSelectedSubService !== '' && !this.getDaysIsClosed(this.getSelectedDay.weekday, false, new Date(this.getSelectedDay.date).getTime())) {
        let did = this.getSelectedDay.weekday
        if (did === 0) did = 7
        return this.findFirstOpenServiceHours({ day: this.getSelectedDay, keepCurrent: true, passed: true, checkLock: false }).then((tabHS) => {
          let newTabHS = tabHS
          // get first disponnible hour
          // check if tables selected is avaible at this time
          let indexHour = 0
          if (this.getSelectedTables.length > 0) {
            let hours = this.getHoursDispoForSelectedTable
            if (hours.length === 0) {
              this.unSelectedTables()
            } else {
              hours.sort((a, b) => {
                return compareTime(a, b)
              })
              indexHour = newTabHS[this.getSelectedSubService].tab.findIndex((element) => {
                return element.hour === hours[0]
              })
              if (indexHour < 0) indexHour = 0
            }
          }

          // format hours if capacity exist
          let lastLenght = 0
          Object.entries(newTabHS).forEach(hs => {
            hs[1].tab.forEach(h => {
              let serviceLooked = this.getMainServiceDataByServiceAndDay(h.ms, this.getSelectedDay.labelDay)
              // real id of tab
              let checkid = parseInt(h.id) - lastLenght
              // if first hour is not the same for opening jump to next id
              if (serviceLooked.opening !== serviceLooked.hMinTakeResa) {
                checkid = checkid + 1
              }
              if (serviceLooked.capacityIntervalTab &&
                serviceLooked.capacityIntervalTab.length > 0 &&
                serviceLooked.capacityIntervalTab[checkid] &&
                serviceLooked.capacityIntervalTab[checkid].capacity > 0
              ) {
                let couvTaked = this.getCouvByHour(h.hour)
                let couvCapacity = serviceLooked.capacityIntervalTab[checkid].capacity
                let couvAvaible = couvCapacity - couvTaked
                if (couvAvaible <= 0) h.color = '#f13030'
                else if (couvAvaible <= (couvCapacity / 2)) h.color = '#e78948'
                h.label = `${h.hour} | ${couvCapacity - couvAvaible}/${couvCapacity}`
              } else if (serviceLooked.capacityIntervalTab &&
                serviceLooked.capacityIntervalTab.length > 0 &&
                serviceLooked.capacityIntervalTab[checkid] &&
                serviceLooked.capacityIntervalTab[checkid].capacity < 0
              ) {
                h.color = '#f13030'
                h.label = `${h.hour} - Fermé`
              } else {
                h.label = h.hour
              }
            })
            lastLenght += hs[1].tab.length
          })

          // set hours
          if (this.getSelectedSubService !== '' && this.getSelectedMainService !== '' && newTabHS[this.getSelectedSubService] !== undefined) {
            this.formPart2.data.date2 = newTabHS[this.getSelectedSubService].tab[indexHour]
            this.setSelectedHour(this.formPart2.data.date2.hour)
          } else {
            this.formPart2.data.date2 = newTabHS[Object.keys(newTabHS)[0]].tab[0]
            this.setSelectedHour(this.formPart2.data.date2.hour)
            this.setSelectedService({ ms: newTabHS[Object.keys(newTabHS)[0]].tab[0].ms, subs: newTabHS[Object.keys(newTabHS)[0]].tab[0].subs })
          }
          this.tabHours = newTabHS
          return newTabHS
        })
      } else {
        return null
      }
    },
    getHoursDispoForSelectedTable: function () {
      let hours = []
      this.getSelectedTables.forEach((tid) => {
        let hoursTable = this.getHourAvaibleForResas(this.getLinkedResaIdsToTable(this.getSelectedRoom, tid))
        if (hours.length === 0) hours = hoursTable.slice(0)
        else if (hoursTable.length > 0) {
          hoursTable.forEach((h) => {
            let index = hours.findIndex((element) => {
              return element === h
            })
            if (index === -1) hours.splice(index, 1)
          })
        }
      })
      return hours
    },
    getCashInfosData: function () {
      return this.cashInfos
    },
    getCashInfos: function () {
      let ts = dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year)
      let service = this.formPart2.data.date2.ms
      this.checkExistCashDays({
        restoid: this.getUidPublic,
        ts: ts,
        service: service
      }).then(res => {
        if (res && res !== '') {
          this.cashInfos = {
            type: res.type,
            value: res.value,
            nbCouv: res.nbCouv
          }
        } else {
          this.cashInfos = undefined
        }
      }).catch(() => {
        this.cashInfos = undefined
      })
      return true
    }
  },
  methods: {
    ...mapMutations({
      setSelectedRoom: 'newRooms/setSelectedRoom',
      setSelectedResa: 'newReservations/setSelectedResa',
      setSelectedTables: 'newRooms/setSelectedTables',
      setPopupTakeResa: 'displayer/setPopupTakeResa',
      setSelectedHour: 'newReservations/setSelectedHour',
      setSelectedService: 'newServices/setSelectedService'
    }),
    ...mapActions({
      createNewResa: 'newReservations/createNewResa',
      createNewClient: 'newClients/createNewClient',
      bookingClientProcess: 'newClients/bookingClientProcess',
      updateClient: 'newClients/updateClient',
      updateClientCount: 'newClients/updateClientCount',
      unSelectedTables: 'newRooms/unSelectedTables',
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      showHidePopupManageServices: 'displayer/showHidePopupManageServices',
      checkExistCashDays: 'cash/checkExistCashDays',
      sendSocketUpdateMessage: 'webSockets/sendSocketUpdateMessage'
    }),
    parseTime(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number)
      return hours * 60 + minutes
    },
    isInInterval(start, end, hour) {
      return hour >= start && hour <= end
    },
    focusNumber: function (e) {
      // focusBlur()
    },
    checkValues: function (e) {
      if (this.formPart2.data.nbCouvert < 1) {
        this.formPart2.data.nbCouvert = 1
      }
      this.formPart2.data.nbCouvert = parseInt(this.formPart2.data.nbCouvert)
    },
    forceLowerCase: function (e) {
      this.formPart1.data.email = this.formPart1.data.email.toLowerCase()
    },
    formatDayWithLowercase(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    setSelectedRoomTo: function (e) {
      this.setSelectedRoom(e)
    },
    setSelectTablesTo: function (e) {
      this.setSelectedTables(e)
    },
    serviceChange: function (e) {
      if (this.getSelectedTables.length > 0) {
        let hours = this.getHoursDispoForSelectedTable
        if (hours.length === 0) {
          this.unSelectedTables()
        } else {
          let found = hours.find((checkedHour) => {
            return checkedHour === this.formPart2.data.date2.hour
          })
          if (found === undefined) this.unSelectedTables()
        }
      }
      this.setSelectedHour(this.formPart2.data.date2.hour)
      if (this.getSelectedSubService !== e.ms) {
        this.setSelectedService({ ms: e.ms, subs: e.subs })
      }
    },
    msServiceChange: function (selected) {
      this.setSelectedService({ ms: selected.ms, subs: selected.subs })
      this.serviceChange(selected)
    },
    getCapacityHour: (hour) => {
      return hour.hour
    },
    closePopup: function () {
      this.setSelectedHour('')
      this.unSelectedTables()
      this.setPopupTakeResa(false)
    },
    onSubmitPart1: function (formName) {
      this.$refs[formName].validate((valid) => {
        let formIsValid = valid

        // form is valid get client info or create a new one
        if (formIsValid) {
          this.formPart1.loading = true
          // bookingClientProcess call
          this.bookingClientProcess({
            restoid: this.getUidPublic,
            clientPreFix: this.formPart1.data.clientPreFix,
            name: this.formPart1.data.name,
            prenom: this.formPart1.data.prenom,
            tel: this.formPart1.data.tel,
            telPreFix: this.formPart1.data.telPreFix,
            email: this.formPart1.data.email,
            civ: this.formPart1.data.civ,
            societe: this.formPart1.data.societe,
            comment: this.formPart1.data.comment
          }).then((res) => {
            // get cid
            this.formPart1.cid = res.cid

            // then update client countForm completed
            this.updateClientCount({ cid: res.cid, type: 'countForm' })

            // if rgpdmail is not assigned (for old client)
            if (res.rgpdmail !== undefined) this.formPart2.data.rgpdmail = res.rgpdmail
            if (res.rgpdsms !== undefined) this.formPart2.data.rgpdsms = res.rgpdsms

            // ending
            this.formPart1.loading = false
            this.switchForm()
          }).catch(err => {
            this.formPart1.loading = false
            // catch error
            console.error('TakeResa - booking process', err)
            // send notification error
            Notification.error({
              title: "Problème rencontré dans l'enregistrement du client",
              position: 'bottom-right'
            })
          })
        } else {
          return false
        }
      })
    },
    getLinkModify: function (resa) {
      let host = `http://${window.location.hostname}`
      let ts = dateToTimeStamp(resa.dateResa.day, resa.dateResa.month - 1, resa.dateResa.year)
      return `${host}/change/${this.getUidPublic.toString()}/${ts.toString()}/${resa.id.toString()}`
    },
    onSubmitPart2: function (formName) {
      this.btnTakeResaDisable = true
      this.formPart2.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // type of resa taked
          let role = 'Restaurant'
          if (this.$router.currentRoute.name === 'PRedirect') role = 'Permanence'

          // if cash caution or prepayement exist
          if (this.getCashInfos && this.cashInfos && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert)) && this.cashProceed) {
            this.btnTakeResaDisable = false
            this.formPart2.loading = false
            // create new cashresa
            let newCashResa = {
              restoid: this.getUidPublic,
              ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year),
              service: this.formPart2.data.date2.ms,
              type: this.cashInfos.type,
              couverts: this.formPart2.data.nbCouvert,
              amount: this.cashInfos.value,
              total: Math.round((parseFloat(this.formPart2.data.nbCouvert) * parseFloat(this.cashInfos.value)) * 100) / 100,
              hour: this.formPart2.data.date2.hour,
              discount: this.formPart2.data.date2.discount ? this.getDiscountAmount : null,
              cid: this.formPart1.cid,
              date: this.getSelectedDay,
              comment: this.formPart2.data.commentResa,
              room: this.getSelectedRoom,
              tids: this.getSelectedTables.slice(0),
              preFix: this.formPart2.data.preFix,
              preFixServ: this.formPart2.data.preFixServ,
              allergen: this.formPart2.data.allergen,
              allergenMessage: this.formPart2.data.allergenMessage,
              stripeid: '',
              setupid: '',
              paidid: '',
              source: role,
              taked: false
            }

            // send to db cashresa
            fetchPostHelper(ERequestType.CASHRESAS.CREATE, newCashResa).then((resCR) => {
              // for prepaiement
              if (this.cashInfos.type === 'prepaiement') {
                // initiate stripe checkout with paiement intent process
                fetchCheckoutApp(
                  this.getUidPublic,
                  this.getAllInfos.restoName,
                  this.cashInfos.type,
                  this.cashInfos.value,
                  this.formPart2.data.nbCouvert,
                  role,
                  resCR.data.id,
                  this.formPart1.data.email,
                  `${this.formPart1.data.name} ${this.formPart1.data.prenom}`,
                  `${this.getAllInfos.restoName}-${this.formPart1.data.civ} ${this.formPart1.data.name} ${this.formPart1.data.prenom} - tel : ${this.formPart1.data.tel} - email : ${this.formPart1.data.email} - service : ${this.formPart2.data.date2.ms} - le : ${this.getSelectedDay.labelDay} ${this.getSelectedDay.label} ${this.getSelectedDay.labelMonth} ${this.getSelectedDay.year} à ${this.formPart2.data.date2.hour}`
                ).then(resCO => {
                  // get new ids for cashresa
                  newCashResa.stripeid = resCO.id
                  newCashResa.paidid = resCO.payment_intent
                  newCashResa.id = resCR.data.id

                  // update cashresa ids datas
                  fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa).then((updatedCR) => {
                    // launch setup intent
                    this.loadStripeCheckout(() => {
                      try {
                        let stripe = window.Stripe(import.meta.env.VITE_PK_STRIPE)
                        stripe.redirectToCheckout({
                          // Make the id field from the Checkout Session creation API response
                          // available to this file, so you can provide it as parameter here
                          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                          sessionId: resCO.id
                        }).then(function (result) {
                          // If `redirectToCheckout` fails due to a browser or network
                          // error, display the localized error message to your customer
                          // using `result.error.message`.
                          console.log(result)
                        })
                      } catch (e) {
                        console.error(e)
                        this.$emit('error', e)
                      } finally {
                        this.$emit('loading', false)
                      }
                    })
                  })
                })
              } else {
                // initiate stripe checkout with paiement intent process
                fetchCheckoutApp(
                  this.getUidPublic,
                  this.getAllInfos.restoName,
                  this.cashInfos.type,
                  this.cashInfos.value,
                  this.formPart2.data.nbCouvert,
                  role,
                  resCR.data.id,
                  this.formPart1.data.email,
                  `${this.formPart1.data.name} ${this.formPart1.data.prenom}`,
                  `${this.getAllInfos.restoName}-${this.formPart1.data.civ} ${this.formPart1.data.name} ${this.formPart1.data.prenom} - tel : ${this.formPart1.data.tel} - email : ${this.formPart1.data.email} - service : ${this.formPart2.data.date2.ms} - le : ${this.getSelectedDay.labelDay} ${this.getSelectedDay.label} ${this.getSelectedDay.labelMonth} ${this.getSelectedDay.year} à ${this.formPart2.data.date2.hour}`
                ).then(resCO => {
                  // get new ids for cashresa
                  newCashResa.stripeid = resCO.id
                  newCashResa.setupid = resCO.setup_intent
                  newCashResa.id = resCR.data.id

                  // update cashresa ids datas
                  fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa).then((updatedCR) => {
                    // launch setup intent
                    this.loadStripeCheckout(() => {
                      try {
                        let stripe = window.Stripe(import.meta.env.VITE_PK_STRIPE)
                        stripe.redirectToCheckout({
                          // Make the id field from the Checkout Session creation API response
                          // available to this file, so you can provide it as parameter here
                          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                          sessionId: resCO.id
                        }).then(function (result) {
                          // If `redirectToCheckout` fails due to a browser or network
                          // error, display the localized error message to your customer
                          // using `result.error.message`.
                          console.log(result)
                        })
                      } catch (e) {
                        console.error(e)
                        this.$emit('error', e)
                      } finally {
                        this.$emit('loading', false)
                      }
                    })
                  })
                })
              }
            })
          } else {
            // create new resa
            this.formPart2.data.room = this.getSelectedRoom
            this.formPart2.data.tids = this.getSelectedTables.slice(0)
            this.createNewResa(
              {
                cid: this.formPart1.cid,
                data: this.formPart2.data,
                date: this.getSelectedDay,
                discount: this.formPart2.data.discount ? this.getDiscountAmount : null,
                state: resaState.CONFIRMED,
                source: role
              }).then((data) => {
                // get client
                let client = this.getClientByid(this.formPart1.cid)
                // client countResa
                client.countResa += 1
                // client rgpdOption
                client.rgpdmail = this.formPart2.data.rgpdmail
                client.rgpdsms = this.formPart2.data.rgpdsms
                const discount = data.discount
                // update client
                this.updateClient(client).then((res) => {
                  // Send mail for client
                  let hourFormatted = formatTimeH(parseTime(data.hour))

                  // for client mail
                  sendResaConfirmedMessage({
                    clientName: `${this.formPart1.data.name} ${this.formPart1.data.prenom}`,
                    clientEmail: this.formPart1.data.email,
                    restoName: this.getAllInfos.restoName,
                    restoEmail: this.getAllInfos.restoMail,
                    dateResa: `${data.dateResa.labelDay} ${data.dateResa.day.toString()} ${data.dateResa.labelMonth} ${data.dateResa.year.toString()}`,
                    hourResa: hourFormatted,
                    message: this.getAllInfos.resaAcceptedMessage,
                    nbCouverts: data.nbCouvert,
                    adresse: this.getAllInfos.restoAdresse,
                    tel: this.getAllInfos.restoTel,
                    url: this.getLinkModify(data),
                    type: data.type,
                    total: data.total,
                    restoid: this.getAllInfos.restoid,
                    discount,
                    sendSms: !!this.getAllInfos.clientSmsSended,
                    clientTel: this.formPart1.data.tel,
                    clientTelPreFix: this.formPart1.data.telPreFix
                  })

                  // for restaurateur
                  if (role === 'Permanence' && this.getAllInfos.restoMailSended !== undefined && this.getAllInfos.restoMailSended) {
                    sendResaTakedRestaurateur({
                      clientName: `${this.formPart1.data.name} ${this.formPart1.data.prenom}`,
                      clientEmail: this.formPart1.data.email,
                      restoName: this.getAllInfos.restoName,
                      restoEmail: this.getAllInfos.restoMail,
                      dateResa: `${data.dateResa.labelDay} ${data.dateResa.day.toString()} ${data.dateResa.labelMonth} ${data.dateResa.year.toString()}`,
                      hourResa: hourFormatted,
                      message: this.getAllInfos.resaFirstMessage,
                      nbCouverts: data.nbCouvert,
                      adresse: this.getAllInfos.restoAdresse,
                      tel: this.getAllInfos.restoTel,
                      source: role,
                      discount
                    })
                  }

                  // re-init forms
                  this.switchForm(true)

                  // send notification success
                  Notification.success({
                    title: 'Nouvelle réservation prise',
                    position: 'bottom-right'
                  })
                  this.formPart2.loading = false
                  // close popup hack for closing popup
                  this.closePopup()
                  // send need to update ws
                  this.sendSocketUpdateMessage()
                }).catch((err) => {
                  Notification.error({
                    title: 'Error update count',
                    message: err.message,
                    position: 'bottom-right'
                  })
                  this.formPart2.loading = false
                })
              }).catch((err) => {
                Notification.error({
                  title: 'Error create new resa',
                  message: err.message,
                  position: 'bottom-right'
                })
                this.formPart2.loading = false
              })
          }
        } else {
          this.formPart2.loading = false
          return false
        }
      })
    },
    loadStripeCheckout: (callback) => {
      let e = document.createElement('script')
      e.src = 'https://js.stripe.com/v3/'
      e.type = 'text/javascript'
      document.getElementsByTagName('head')[0].appendChild(e)
      e.addEventListener('load', callback)
    },
    querySearchName: async function (queryString, cb) {
      const res = await fetchGetHelper(ERequestType.CLIENTS.SEARCH, `restoId=${this.getUidPublic}&query=${queryString}`)
      const results = res.data

      console.log('results', results)
      cb(results)
    },
    handleSelectClient: function (client) {
      this.formPart1.data.civ = client.civ
      this.formPart1.data.name = client.name
      this.formPart1.data.prenom = client.prenom
      this.formPart1.data.clientPreFix = client.clientPreFix
      this.formPart1.data.email = client.email
      this.formPart1.data.tel = client.tel
      this.formPart1.data.telPreFix = client.telPreFix
      this.formPart1.data.societe = client.societe
      this.formPart1.data.comment = client.comment
    },
    switchForm: function (reset = false) {
      if (this.formPart1.show) {
        this.formPart1.show = false
        this.formPart2.show = true
      } else {
        this.formPart2.show = false
        this.formPart1.show = true
      }
      if (reset) { }
    }
  },
  destroyed: function () {
    this.setSelectedHour('')
  },
  created: function () {
    this.rulesFormPart1 = {
      email: [
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ],
      name: [
        { required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }
      ],
      prenom: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      tel: [
        { validator: checkPhone, trigger: 'blur' }
      ],
      telPreFix: [
        { validator: (rule, value, callback) => validatePrefix(rule, value, callback, this.formPart1.data.tel), trigger: 'blur' }
      ]
    }
    this.rulesFormPart2 = {
      allergen: [
        { required: true, message: 'Merci de renseigner si vous avez des intolérances / allergies', trigger: 'change' }
      ],
      allergenMessage: [
        { required: true, message: 'Veuillez renseigner les intolérances / allergies', trigger: 'blur' }
      ]
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@use "../../styles/vars";

.errorContact {
  color: var(--color_red);
  text-align: center;
  line-height: 16px;
}

.autocomp {
  &-prenom {
    margin-right: 10px
  }

  &-show {
    color: var(--color_gold);
    font-weight: normal;
  }

  &-star {
    background-image: url("../../assets/svg/asset-star.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 12px;
    width: 12px;
    height: 12px;
    display: inline-block;
    margin-right: 10px
  }

  &-noshow {
    color: var(--color_red);
    font-size: 14px;
    font-weight: normal;
  }

  &-thumb-down {
    background-image: url("../../assets/svg/asset-thumb-down.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 12px;
    width: 12px;
    height: 12px;
    display: inline-block;
  }
}

.el-radio,
.el-radio__inner,
.el-radio__input {
  display: flex;
}

.tel {
  width: 75%;
  margin-left: 1%;
  display: inline-block;

  &-prefix {
    width: 22%;
    display: inline-block;

    input {
      text-align: right;
    }
  }
}

.civ {
  width: 100%;
  display: inline-block;
}

.cPrefix {
  width: 26%;
  margin-left: 2%;
  display: inline-block;
}

.rPrefix {
  width: 100%;
  display: inline-block;
}

.spanModified {
  width: 95%;
  text-align: center;
  display: block;
}

.popup-takeResa-promotion {
  .promo {
    background-color: var(--color_red);
    color: white;
    padding: 5px;
    border-radius: 5px;
    font-weight: bold;
    margin-left: 3px;
  }
}
</style>
